import { useEffect, useState } from 'react';

import transakSDK from '@transak/transak-sdk'
import { useGlobalState } from 'state-pool';
import Modal from 'components/general/Modal';
import { Paragraph } from '@material-tailwind/react';
import Button from '@material-tailwind/react/Button';

let transakData = {
    // TODO API key to be moved to .env
    apiKey: process.env.REACT_APP_TRANSAK_API_KEY,  // Your API Key
    environment: process.env.REACT_APP_TRANSAK_ENVIRONMENT, // STAGING/PRODUCTION
    defaultCryptoCurrency: 'btc',
    walletAddress: '', // Your customer's wallet address
    themeColor: '000000', // App theme color
    fiatCurrency: 'ZAR', // INR/GBP
    email: '', // Your customer's email address
    redirectURL: '',
    hostURL: window.location.origin,
    widgetHeight: '550px',
    widgetWidth: '450px'
}

export default function Transak({ className, children }) {
    const [currentUser] = useGlobalState('currentUser');
    const [transakInstance, setTransakInstance] = useState(null);
    const [paymentSuccess, setPaymentSuccess] = useState(false);

    function handleTransakCick(){
        if (transakInstance) {
            transakInstance.init();

        transakInstance.on(transakInstance.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
            console.log(orderData);
            transakInstance.close();
            setPaymentSuccess(true);
        });
        }else{
            return;
        }

    }

    useEffect(() => {
        if(currentUser && currentUser.email && currentUser.btc_pubkey) {
            transakData.email = currentUser.email;
            transakData.walletAddress = currentUser.btc_pubkey;

            const { email, btc_pubkey } = currentUser;

            if(email && btc_pubkey) {
                let t = new transakSDK({...transakData, email, walletAddress: btc_pubkey});

                setTransakInstance(t);

            }
        }
    
    }, [currentUser]);

    return (
        <>
            <div className={className ? className : ""} onClick={handleTransakCick}>
                {children}
            </div>

            <Modal
                showModal={paymentSuccess}
                setShowModal={setPaymentSuccess}
                size="sm"
            >
                <h3 className="text-white font-light text-xl mb-5">
                            Payment successful
                </h3>
                <div className="p-5">
                    <Paragraph color="white">
                        Your payment was successfully processed.
                    </Paragraph>
                    <div className="h-5" />
                    <Button
                        color="green"
                        className="w-full"
                        buttonType="filled"
                        size="lg"
                        ripple="dark"
                        onClick={() => setPaymentSuccess(false)}
                    >
                        Okay
                    </Button>
                </div>
            </Modal>
        </>
        
    )
}
